import { FIELDS } from './constants';

export const INITIAL_STATE = Object.values(FIELDS).reduce(
  (acc, key) => {
    acc[key] ??= [];

    return acc;
  },
  { [FIELDS.ERROR]: undefined, [FIELDS.LOADING]: false }
);
